// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"145":"4cc931cc","162":"bb6fb04d","474":"232a87bb","605":"d7f30215","645":"874fc6f2","852":"899816e3","884":"2535c0b2"}[chunkId] + ".css";
};